export default __webpack_public_path__ + "static/media/fleet_icon.180bc2a6.svg";